import ToolbarIconButton from './ToolbarIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarActionButtons = ({
  buttonActions,
  hasDropdown,
  active,
  lastButtonRounding,
  iconUse,
  rotateActionIcons,
  isTrellisTheme,
  variant
}) => {
  return buttonActions.map(({
    id: actionId,
    callback,
    icon: ActionIcon,
    tooltipLabel,
    disabled,
    placement,
    autoPlacement,
    ariaLabel
  }, i) => {
    const isLastButton = i === buttonActions.length - 1;
    const cornerToRound = !hasDropdown && isLastButton ? lastButtonRounding : undefined;
    return /*#__PURE__*/_jsx(ToolbarIconButton, {
      borderInlineEndWidth: !hasDropdown && isLastButton ? '100' : '0',
      icon: ActionIcon,
      use: iconUse,
      isToolbarActive: active,
      disabled: disabled,
      onClick: disabled ? undefined : callback,
      placement: placement,
      autoPlacement: autoPlacement,
      cornerToRound: cornerToRound,
      tooltip: tooltipLabel,
      rotate: rotateActionIcons,
      isTrellisTheme: isTrellisTheme,
      "aria-label": ariaLabel,
      variant: variant === 'aiEditor' ? 'aiEditor' : 'default'
    }, actionId);
  });
};
export default ToolbarActionButtons;